import "./css/App.css";
import "./css/common.module.css";
import { Route, Routes, Navigate } from "react-router-dom";
import { QueryClientProvider, QueryClient } from 'react-query';
import Login from "./pages/Account/Login";
import HomePage from "./pages/Home/HomePage";
import AboutUs from "./pages/AboutUs/AboutUs";
import Logoff from "./pages/Account/Logoff";
import ListUsers from "./pages/Admin/ListUsers";
import ListCompanies from "./pages/Admin/ListCompanies";
import ListSubsidiaries from "./pages/Admin/ListSubsidiaries";
import ListPartners from "./pages/Admin/ListPartners";
import ListDepartments from "./pages/Admin/ListDepartments";
import ListWorkLocations from "./pages/Admin/ListWorkLocations";
import ListCommodities from "./pages/Admin/ListCommodities";
import ListCompanyProducts from "./pages/Admin/ListCompanyProducts";
import ListSurveyProducts from "./pages/Admin/ListSurveyProducts.jsx";
import ListCompanySurvey from "./pages/Admin/ListCompanySurvey.jsx";
import ListPartnerDelegates from "./pages/Admin/ListPartnerDelegates";
import Landing from "./pages/Home/Landing";
import AnalyticsLanding from "./pages/Analytics/AnalyticsLanding.jsx";
import DisplaySupplyChain from "./pages/Admin/DisplaySupplyChain.jsx";
import ErrorPage from "./pages/Navigation/ErrorPage";
import RootPage from "./pages/Root/RootPage";
import ListScores from "./pages/Analytics/ListScores.jsx";
import SupplierAnalyticsChart from "./pages/Analytics/SupplierAnalyticsChart";
import EditSupplyChain from "./pages/Admin/EditSupplyChain";
import { UserContextProvider } from "./contexts/UserContext";


function App() {
  const queryClient = new QueryClient();
  return (
    <UserContextProvider>
    <QueryClientProvider client={queryClient}>
      <Routes>
      	<Route path="/" element={ <RootPage /> }/>
      	<Route path="/Login" element={<Login />} />
      	<Route path="/error" element={<ErrorPage />} />
        
        <Route path="/pages/landing" element={<Landing />} />
        <Route path="/pages/logoff" element={<Logoff />} />
        <Route path="/pages/home" element={<HomePage />} />
        <Route path="/pages/welcome" element={<HomePage />} />
        <Route path="/pages/aboutus" element={<AboutUs />} />
        <Route path="/pages/users" element={<ListUsers />} />
        <Route path="/pages/companies" element={<ListCompanies />} />
        <Route path="/pages/subsidiaries" element={<ListSubsidiaries />} />
        <Route path="/pages/partners" element={<ListPartners />} />
        <Route path="/pages/departments" element={<ListDepartments />} />
        <Route path="/pages/locations" element={<ListWorkLocations />} />
        <Route path="/pages/commodity" element={<ListCommodities />} />
        <Route path="/pages/comproducts" element={<ListCompanyProducts />} />
		<Route path="/pages/surveyproducts" element={<ListSurveyProducts />} />
		<Route path="/pages/compsurveys" element={<ListCompanySurvey />} />
		<Route path="/pages/analyticsLanding" element={<AnalyticsLanding />} />
        <Route path="/pages/analytics" element={<ListScores />} />
        <Route path="/pages/partnerDelegate" element={<ListPartnerDelegates />} />
        <Route path="/pages/supplierAnalyticsChart" element={<SupplierAnalyticsChart />} />
        <Route path="/pages/partnerDelegateDisplay" element={<DisplaySupplyChain />} />
        <Route path="/pages/partnerDelegateEdit" element={<EditSupplyChain />} />
        <Route path='*' element={<Navigate to="/" replace />} />
      </Routes>
      </QueryClientProvider>
    </UserContextProvider>
  );
}

export default App;
